import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import SecurityStatementPage from 'components/Landing/SecurityStatementPage/SecurityStatementPage';

import { registerComponents } from '../src/registrations';

registerComponents({ SecurityStatementPage });
